import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
  state: { //数据源
    token: '',
    isLogin: false,
    manageId: '',
    manageLogin: false,
    maintainId: '',
    maintainLogin: false,
    newArr: '',
    date:'',
    userRemark:''
  },
  // 获取属性的状态
  getters: {
    //获取登录状态
    isLogin: state => state.isLogin,
  },
  mutations: { //修改值
    SET_TOKEN(state, token) {
      state.token = token
      state.isLogin = true
    },
    SET_MANAGE(state, uid) {
      state.manageId = uid
      state.manageLogin = true
    },
    SET_MAINTAIN(state, uid) {
      state.maintainId = uid
      state.maintainLogin = true
    },
    SET_ARR(state, news) {
      state.newArr = news
    },
    SET_DATE(state, da){
      state.date = da
    },
    SET_REMARK(state, re){
      state.userRemark = re
    }
  },
  actions: {
    setToken({
      commit
    }, token) {
      commit('SET_TOKEN', token);
      localStorage.setItem("tokenId", token);
      localStorage.setItem("Flag", "isLogin");
    },
    setManage({
      commit
    }, uid) {
      commit('SET_MANAGE', uid);
      localStorage.setItem("manageId", uid);
      localStorage.setItem("ManageFlag", "isLogin");
    },
    setMaintain({
      commit
    }, uid) {
      commit('SET_MAINTAIN', uid);
      localStorage.setItem("maintainId", uid);
      localStorage.setItem("MaintainFlag", "isLogin");
    },
    setNewArr({
      commit
    }, news) {
      commit('SET_ARR', news);
    },
    setDate({
      commit
    }, da) {
      commit('SET_DATE', da);
    },
    setRemark({
      commit
    }, re) {
      commit('SET_REMARK', re);
    },
  }
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js